import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { addProvider } from "../slice/workerRegisterSlice";
import { login, saveTokenInLocalStorage } from "../../worker-auth/slice/workerAuthSlice";
import { startFreePilot, storeProviderBenefitsStability, storeFreeProviderBenefitsStability } from "../../worker-panel/slice/provider_benefit_stabilitySlice";
import WorkerHeader from "../../worker-header/components/index";
import WorkerFooter from "../../worker-footer/components/index";
const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

const STATES = [
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' },
];

const providerTypeOptions = [
    { value: "center_based", label: "Childcare Center" },
    { value: "family_childcare", label: "Family childcare home" },
    { value: "multi_site", label: "Multi-site provider" },
    { value: "other", label: "Other" },
];

const staffCountOptions = [
    { value: "1_5", label: "1–5 staff" },
    { value: "6_10", label: "6–10 staff" },
    { value: "11_25", label: "11–25 staff" },
    { value: "26_plus", label: "26+ staff" },
];

const mainSupportInterestOptions = [
    { value: "staffing_support", label: "Staffing support" },
    { value: "benefits_readiness", label: "Benefits readiness" },
    { value: "workforce_onboarding", label: "Workforce onboarding" },
    { value: "compliance/resource_navigation", label: "Compliance/resource navigation" },
    { value: "not_sure", label: "Not sure yet" },
]

const CTARequesTypeOptions = [
    { value: "start_benefit", label: "I want to start the Benefits Readiness Survey" },
    { value: "ncaf_contact", label: "I want NCAF to contact me" },
    { value: "more_information", label: "I want more information first" },
]

const OptionCardGroup = ({
    label,
    description,
    options,
    value,
    onChange,
    multiple = false,
    error,
}) => {
    return (
        <div className={`mb-4 ${error ? "border border-danger rounded p-3" : ""
            }`}>
            <div className="mb-3">
                <h3 className="fs-6 fw-semibold text-dark">
                    {label}
                </h3>

                {description && (
                    <p className="small text-muted mt-1 mb-0">
                        {description}
                    </p>
                )}

                {error && (
                    <div className="text-danger small mt-1">
                        {error}
                    </div>
                )}
            </div>

            <div className="row g-3">
                {options.map((option) => {
                    const selected = multiple
                        ? value?.includes(option.value)
                        : value === option.value;

                    return (
                        <div key={option.value} className="col-12 col-md-6">
                            <button
                                type="button"
                                onClick={() => onChange(option.value)}
                                className={`w-100 text-start border rounded p-3 bg-white ${selected
                                    ? "border-primary"
                                    : "border-secondary-subtle"
                                    }`}
                                style={{
                                    backgroundColor: selected
                                        ? "#002B4515"
                                        : "#fff",
                                    transition: "all 0.2s ease",
                                }}
                            >
                                <div className="d-flex align-items-start gap-3">

                                    {multiple ? (
                                        <input
                                            type="checkbox"
                                            checked={selected}
                                            readOnly
                                            className="form-check-input mt-1"
                                            style={{
                                                pointerEvents: "none",
                                            }}
                                        />
                                    ) : (
                                        <input
                                            type="radio"
                                            checked={selected}
                                            readOnly
                                            className="form-check-input mt-1"
                                            style={{
                                                pointerEvents: "none",
                                            }}
                                        />
                                    )}

                                    <span
                                        className="fw-medium"
                                        style={{
                                            color: selected
                                                ? "#002B45"
                                                : "#212529",
                                            fontSize: "14px",
                                        }}
                                    >
                                        {option.label}
                                    </span>
                                </div>
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const FreePilotRegistration = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [activeSection, setActiveSection] = useState("provider_basics");
    const [showModal, setShowModal] = useState(false);
    const [email, setEmail] = useState("");
    const [emailExists, setEmailExists] = useState(false);
    const [loading, setLoading] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const [concentErrors, setConcentErrors] = useState({
        processing_consent: false,
    });

    const params = new URLSearchParams(window.location.search);

   const getTrafficSourceCookie = () => {
    try {
      const cookieValue = document.cookie
        .split("; ")
        .find((cookie) => cookie.startsWith("ncaf_traffic_source="));

      if (!cookieValue) return null;

      const rawValue = decodeURIComponent(cookieValue.split("=").slice(1).join("="));
      return JSON.parse(rawValue);
    } catch (error) {
      console.error("Failed to parse ncaf_traffic_source cookie:", error);
      return null;
    }
  };

  // ✅ Priority 1: Cookie | Priority 2: URL Params | Priority 3: null
  const getActiveAttribution = () => {
    // 1. Check Cookie first
    const cookieData = getTrafficSourceCookie();
    if (cookieData && (cookieData.utm_source || cookieData.utm_medium || cookieData.utm_campaign)) {
      return {
        utm_source: cookieData.utm_source || null,
        utm_medium: cookieData.utm_medium || null,
        utm_campaign: cookieData.utm_campaign || null,
        utm_content: cookieData.utm_content || null,
        utm_term: cookieData.utm_term || null,
        referrer: cookieData.referrer_url || null,
        landing_page_url: cookieData.landing_page_url || window.location.href,
      };
    }

    // 2. Fallback to URL search parameters
    const utmSource = params.get("utm_source");
    const utmMedium = params.get("utm_medium");
    const utmCampaign = params.get("utm_campaign");
    const utmContent = params.get("utm_content");
    const utmTerm = params.get("utm_term");

    if (utmSource || utmMedium || utmCampaign || utmContent || utmTerm) {
      return {
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_content: utmContent,
        utm_term: utmTerm,
        referrer: document.referrer || null,
        landing_page_url: window.location.href,
      };
    }

    // 3. If neither is available, return null values
    return {
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_content: null,
      utm_term: null,
      referrer: document.referrer || null,
      landing_page_url: window.location.href,
    };
  };

  // ✅ Initialize attribution (ONLY FIRST TIME)
  const initAttribution = () => {
    const existing = localStorage.getItem("utm_data");

    if (!existing) {
      const active = getActiveAttribution();
      const data = {
        ...active,
        benefits_intake_started_at: null,
        benefits_intake_completed_at: null,
      };

      localStorage.setItem("utm_data", JSON.stringify(data));
    }
  };

  // ✅ Get attribution anytime
  const getAttribution = () => {
    return JSON.parse(localStorage.getItem("utm_data") || "{}");
  };

    // ✅ Initialize attribution (ONLY FIRST TIME)
    // const initAttribution = () => {
    //     const existing = localStorage.getItem("utm_data");

    //     if (!existing) {
    //         const data = {
    //             ...getUTMParams(),
    //             referrer: document.referrer || null,
    //             landing_page_url: window.location.href,
    //             benefits_intake_started_at: null,
    //             benefits_intake_completed_at: null,
    //         };

    //         localStorage.setItem("utm_data", JSON.stringify(data));
    //     }
    // };

    // // ✅ Get attribution anytime
    // const getAttribution = () => {
    //     return JSON.parse(localStorage.getItem("utm_data") || "{}");
    // };

    // ✅ Update attribution (merge)
    // const updateAttribution = (updates) => {
    //     const existing = getAttribution();

    //     const updated = {
    //         ...existing,
    //         ...updates,
    //     };

    //     localStorage.setItem("utm_data", JSON.stringify(updated));
    // };

    useEffect(() => {
        initAttribution();
    }, []);

    const navigateToErrorSection = (errors) => {
        console.log("navigateToErrorSection called");
        console.log("errors", errors);

        const sectionMap = {
            provider_name: "provider_basics",
            contact_name: "provider_basics",
            contact_email: "provider_basics",
            contact_phone: "provider_basics",
            state: "provider_basics",
            provider_type: "provider_basics",
            staff_count_range: "provider_basics",
            support_interest: "provider_basics",
            request_type: "provider_basics",
        };

        const firstErrorField = Object.keys(errors)[0];

        console.log("firstErrorField", firstErrorField);
        console.log("target section", sectionMap[firstErrorField]);

        if (firstErrorField && sectionMap[firstErrorField]) {
            setActiveSection(sectionMap[firstErrorField]);
        }
    };


    useEffect(() => {
        setShowModal(true);
    }, []);

    const handleInputChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const [formData, setFormData] = useState({
        provider_name: "",
        contact_name: "",
        contact_email: "",
        contact_phone: "",
        city: "",
        state: "AL",
        country: "",
        provider_type: "",
        staff_count_range: "",
        support_interest: "",
        request_type: "",
        processing_consent: false,
        ncaf_follow_up_consent: false,
    });

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // or "auto"
        });
    }, [activeSection]);

    const checkEmail = async () => {
        if (!email) return;

        setLoading(true);

        try {
            const response = await fetch(`${BACKEND_URL}/checkEmail`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (data.success) {
                if (data.message === "Email already exists.") {
                    setEmailExists(true);
                } else if (data.message === "Email not found. Please sign up to continue.") {

                    // window.dataLayer = window.dataLayer || [];
                    // window.dataLayer.push({
                    //     event: "benefits_intake_started",
                    //     entry_flow: "pre_login",
                    //     entry_page: "/free-pilot-registration",
                    //     authentication_status: "guest",
                    //     provider_user_id: undefined,
                    //     utm_source: params.get("utm_source"),
                    //     utm_medium: params.get("utm_medium"),
                    //     utm_campaign: params.get("utm_campaign"),
                    //     utm_content: params.get("utm_content"),
                    //     utm_term: params.get("utm_term"),
                    //     referrer: document.referrer || null,
                    //     landing_page_url: window.location.href,

                    const attribution = getActiveAttribution();

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "benefits_intake_started",
                        entry_flow: "pre_login",
                        entry_page: "/free-pilot-registration",
                        authentication_status: "guest",
                        provider_user_id: undefined,
                        utm_source: attribution.utm_source,
                        utm_medium: attribution.utm_medium,
                        utm_campaign: attribution.utm_campaign,
                        utm_content: attribution.utm_content,
                        utm_term: attribution.utm_term,
                        referrer: attribution.referrer,
                        landing_page_url: attribution.landing_page_url,
                    });

                    setFormData((prev) => ({
                        ...prev,
                        contact_email: email,
                        benefits_intake_started_at: new Date().toISOString(),
                    }));

                    setShowModal(false);
                }
            }
        } catch (error) {
            console.error("Error checking email:", error);
        } finally {
            setLoading(false);
        }
    };

    const changeEmail = () => {
        // setEmail("");
        setEmailExists(false);
    };

    const validateForm = () => {
        console.log("validateForm called");
        const errors = {};

        if (!formData.provider_name) {
            errors.provider_name = "Provider name is required.";
        }

        if (!formData.contact_name) {
            errors.contact_name = "Contact name is required.";
        }

        if (!formData.contact_email) {
            errors.contact_email = "Contact Email is required.";
        }

        if (!formData.city) {
            errors.city = "City is required.";
        }

        if (!formData.country) {
            errors.country = "Country is required.";
        }

        if (!formData.provider_type) {
            errors.provider_type = "Provider type is required.";
        }

        if (!formData.staff_count_range) {
            errors.staff_count_range = "Staff count range is required.";
        }

        if (!formData.support_interest) {
            errors.support_interest = "Support interest is required.";
        }

        if (!formData.request_type) {
            errors.request_type = "Request type is required.";
        }

        return errors;
    };

    const handleSubmit = async () => {
        console.log("handleSubmit called");

        if (!formData.processing_consent) {
            setConcentErrors({
                processing_consent: true,
            });
            return;
        }

        setConcentErrors({
            processing_consent: false,
        });
        try {
            const errors = validateForm();

            if (Object.keys(errors).length > 0) {
                setValidationErrors(errors);
                const firstError = Object.values(errors)[0];
                toast.error(firstError);
                // navigateToErrorSection(errors);
                return;
            }
            setLoading(true);
            // API flow continues here

        } catch (err) {
            console.error(err);

            const errors = err?.errors || {};
            setValidationErrors(errors);

            // navigateToErrorSection(errors);

            toast.error(
                err?.message || "Please correct the highlighted fields."
            );
        }
        try {

            // setValidationErrors({});

            // ✅ Derived flag (Point 5)
            // const isPartnerFollowupRequested = [
            //     "interested_now",
            //     "ready_referral",
            // ].includes(formData.partner_followup_interest);

            // // ✅ Clean payload (Point 6)
            // const payload = {
            //     ...formData,
            //     full_time_count:
            //         formData.full_time_count === ""
            //             ? null
            //             : Number(formData.full_time_count),

            //     part_time_count:
            //         formData.part_time_count === ""
            //             ? null
            //             : Number(formData.part_time_count),

            //     partner_followup_requested: isPartnerFollowupRequested,
            // };

            // ============================
            // 1. REGISTER PROVIDER
            // ============================
            const autoPassword = Array.from(
                crypto.getRandomValues(new Uint8Array(4))
            )
                .map((b) => b.toString(16).padStart(2, "0"))
                .join("");

            const registerPayload = {
                first_name: formData.provider_name,
                email: formData.contact_email,
                phone: formData.contact_phone,
                password: autoPassword,
                c_password: autoPassword,
                states: formData.state,
                city: formData.city,
                county: formData.country,
                role_id: 3,
                role: "provider",
                free_pilot: true
            };

            try {
                // 1. Register
                const registerResponse = await dispatch(
                    addProvider(registerPayload)
                ).unwrap();

                console.log("Register success", registerResponse);
                // window.dataLayer = window.dataLayer || [];
                // window.dataLayer.push({
                //     event: "free_pilot_registration_completed",
                //     entry_flow: "pre_login",
                //     entry_page: "/free-pilot-registration",
                //     authentication_status: "guest",
                //     provider_user_id: undefined,
                //     utm_source: params.get("utm_source"),
                //     utm_medium: params.get("utm_medium"),
                //     utm_campaign: params.get("utm_campaign"),
                //     utm_content: params.get("utm_content"),
                //     utm_term: params.get("utm_term"),
                //     referrer: document.referrer || null,
                //     landing_page_url: window.location.href,

                const attribution = getActiveAttribution();

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "free_pilot_registration_completed",
                    entry_flow: "pre_login",
                    entry_page: "/free-pilot-registration",
                    authentication_status: "guest",
                    provider_user_id: undefined,
                    utm_source: attribution.utm_source,
                    utm_medium: attribution.utm_medium,
                    utm_campaign: attribution.utm_campaign,
                    utm_content: attribution.utm_content,
                    utm_term: attribution.utm_term,
                    referrer: attribution.referrer,
                    landing_page_url: attribution.landing_page_url,
                });

                // 2. Login
                const loginResponse = await dispatch(
                    login({
                        email: formData.contact_email,
                        password: autoPassword,
                        device_name: "test"
                    })
                ).unwrap();

                console.log("Login success", loginResponse);

                const { token: access_token, user } = loginResponse.data;

                const token = access_token.includes("|")
                    ? access_token.split("|")[1]
                    : access_token;

                saveTokenInLocalStorage(token);
                localStorage.setItem("user_id", JSON.stringify(user.id));

                // Adjust this based on your login response structure
                // const token =
                //     loginResponse.token ||
                //     loginResponse.data?.token ||
                //     loginResponse.access_token;

                // 3. Start Free Pilot
                const freePilotResponse = await dispatch(
                    startFreePilot(token)
                ).unwrap();

                console.log("Free Pilot success", freePilotResponse);
                const finalPayload = {
                    ...formData,
                    benefits_intake_started_at: formData.benefits_intake_started_at,
                    benefits_intake_completed_at: new Date().toISOString(),
                    // attribution: {
                    //     utm_source: params.get("utm_source"),
                    //     utm_medium: params.get("utm_medium"),
                    //     utm_campaign: params.get("utm_campaign"),
                    //     utm_content: params.get("utm_content"),
                    //     utm_term: params.get("utm_term"),
                    //     referrer: document.referrer || null,
                    //     landing_page_url: window.location.href,
                    // },
                    attribution: getActiveAttribution(),
                };


                // 4. Store Provider Benefits Stability
                const storeResponse = await dispatch(
                    storeFreeProviderBenefitsStability({
                        token,
                        formData: finalPayload,
                    })
                ).unwrap();

                console.log("Store success", storeResponse);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    // event: "benefits_intake_submitted",
                    // entry_flow: "pre_login",
                    // entry_page: "/free-pilot-registration",
                    // authentication_status: "guest",
                    // provider_user_id: undefined,
                    // utm_source: params.get("utm_source"),
                    // utm_medium: params.get("utm_medium"),
                    // utm_campaign: params.get("utm_campaign"),
                    // utm_content: params.get("utm_content"),
                    // utm_term: params.get("utm_term"),
                    // referrer: document.referrer || null,
                    // landing_page_url: window.location.href,
                    event: "benefits_intake_submitted",
                    entry_flow: "pre_login",
                    entry_page: "/free-pilot-registration",
                    authentication_status: "guest",
                    provider_user_id: undefined,
                    utm_source: attribution.utm_source,
                    utm_medium: attribution.utm_medium,
                    utm_campaign: attribution.utm_campaign,
                    utm_content: attribution.utm_content,
                    utm_term: attribution.utm_term,
                    referrer: attribution.referrer,
                    landing_page_url: attribution.landing_page_url,
                });

                // 5. Redirect
                navigate("/panel/provider-benefit-boundary-setup");

                window.dataLayer.push({
                    // event: "readiness_result_viewed",
                    // entry_flow: "pre_login",
                    // entry_page: "/free-pilot-registration",
                    // authentication_status: "guest",
                    // provider_user_id: undefined,
                    // utm_source: params.get("utm_source"),
                    // utm_medium: params.get("utm_medium"),
                    // utm_campaign: params.get("utm_campaign"),
                    // utm_content: params.get("utm_content"),
                    // utm_term: params.get("utm_term"),
                    // referrer: document.referrer || null,
                    // landing_page_url: window.location.href,
                    event: "readiness_result_viewed",
                    entry_flow: "pre_login",
                    entry_page: "/free-pilot-registration",
                    authentication_status: "guest",
                    provider_user_id: undefined,
                    utm_source: attribution.utm_source,
                    utm_medium: attribution.utm_medium,
                    utm_campaign: attribution.utm_campaign,
                    utm_content: attribution.utm_content,
                    utm_term: attribution.utm_term,
                    referrer: attribution.referrer,
                    landing_page_url: attribution.landing_page_url,
                });

            } catch (error) {
                console.error("Process failed:", error);
            }

            // toast.success(res?.message || "Submitted successfully");

        } catch (err) {
            console.error(err);

            const errors = err?.errors || {};
            setValidationErrors(errors);

            // window.dataLayer = window.dataLayer || [];
            // window.dataLayer.push({
            //     event: "benefits_intake_submit_failed",
            //     entry_flow: "pre_login",
            //     entry_page: "/free-pilot-registration",
            //     authentication_status: "guest",
            //     provider_user_id: undefined,
            //     utm_source: params.get("utm_source"),
            //     utm_medium: params.get("utm_medium"),
            //     utm_campaign: params.get("utm_campaign"),
            //     utm_content: params.get("utm_content"),
            //     utm_term: params.get("utm_term"),
            //     referrer: document.referrer || null,
            //     landing_page_url: window.location.href,
            //     benefit_error_message:
            //         err?.message ||
            //         "Benefits intake submission failed",
            // });
            const attribution = getActiveAttribution();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "benefits_intake_submit_failed",
                entry_flow: "pre_login",
                entry_page: "/free-pilot-registration",
                authentication_status: "guest",
                provider_user_id: undefined,
                utm_source: attribution.utm_source,
                utm_medium: attribution.utm_medium,
                utm_campaign: attribution.utm_campaign,
                utm_content: attribution.utm_content,
                utm_term: attribution.utm_term,
                referrer: attribution.referrer,
                landing_page_url: attribution.landing_page_url,
                benefit_error_message:
                    err?.message ||
                    "Benefits intake submission failed",
            });

            toast.error(
                err?.message || "Please correct the highlighted fields."
            );

            // navigateToErrorSection(errors);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <WorkerHeader />
            {/* Bootstrap Modal */}
            {showModal && (
                <>
                    <div
                        className="modal fade show"
                        style={{ display: "block" }}
                        tabIndex="-1"
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        {emailExists ? "Account Already Exists" : "Enter Email"}
                                    </h5>
                                </div>

                                <div className="modal-body">
                                    {!emailExists ? (
                                        <>
                                            <input
                                                type="email"
                                                className="form-control"
                                                placeholder="Enter Email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />

                                            <button
                                                className="btn btn-primary w-100 mt-3"
                                                onClick={checkEmail}
                                                disabled={loading}
                                            >
                                                {loading ? "Checking..." : "Continue"}
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <p>
                                                Please sign in to continue your Benefits Readiness Setup.
                                            </p>

                                            <div className="d-flex justify-content-end gap-2">
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={changeEmail}
                                                >
                                                    Change Email
                                                </button>

                                                <button
                                                    className="btn btn-primary"
                                                    onClick={() => navigate("/signin")}
                                                >
                                                    Go to Sign In
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Bootstrap Backdrop */}
                    <div className="modal-backdrop fade show"></div>
                </>
            )}

            {/* Registration Form */}
            {!showModal && (
                // <div className="container mt-4 mb-4">

                //     <div
                //         className="mx-auto"
                //     >
                //         <div className="mb-5">
                //             <p
                //                 className="text-uppercase text-primary fw-bold small mb-2"
                //                 style={{ letterSpacing: "0.08em" }}
                //             >
                //                 NCAF Provider Support
                //             </p>

                //             <div className="d-flex justify-content-between">
                //                 <div>
                //                     <h1 className="fw-bold">
                //                         Benefits Readiness Setup
                //                     </h1>
                //                 </div>
                //             </div>


                //             <p className="mt-2">
                //                 Help NCAF understand your workforce stability and benefits readiness
                //                 so we can recommend the right next step.
                //             </p>

                //             <p
                //                 className="mt-3 border-start border-4 ps-3 fw-bold"
                //                 style={{ borderColor: "#bfdbfe" }}
                //             >
                //                 NCAF does not act as an insurance broker, benefits administrator,
                //                 providers, or state licensing authority. This intake helps identify
                //                 readiness and appropriate resource pathways.
                //             </p>
                //         </div>
                //     </div>
                //     <>
                //         <div className="mb-4">
                //             <div className="d-flex align-items-center justify-content-between small text-muted">
                //                 <span>
                //                     Step {currentIndex + 1} of {sections.length}
                //                 </span>
                //                 <span>{currentSection.title}</span>
                //             </div>

                //             <div className="progress mt-2" style={{ height: "8px" }}>
                //                 <div
                //                     className="progress-bar"
                //                     role="progressbar"
                //                     style={{
                //                         width: `${((currentIndex + 1) / sections.length) * 100}%`,
                //                     }}
                //                     aria-valuenow={((currentIndex + 1) / sections.length) * 100}
                //                     aria-valuemin="0"
                //                     aria-valuemax="100"
                //                 />
                //             </div>
                //         </div>


                //         <div className="card border shadow-sm p-3">
                //             <div className="mb-4">
                //                 <h2 className="h4 fw-semibold text-dark">
                //                     {currentSection.title}
                //                 </h2>
                //                 <p className="mt-1 text-muted small">
                //                     {currentSection.description}
                //                 </p>
                //             </div>

                //             {renderSection()}

                //             <div className="d-flex justify-content-between mt-4">
                //                 <button
                //                     type="button"
                //                     onClick={goBack}
                //                     disabled={currentIndex === 0}
                //                     className="btn btn-outline-secondary"
                //                 >
                //                     Back
                //                 </button>

                //                 {activeSection !== "review_submit" && (
                //                     <button
                //                         type="button"
                //                         onClick={goNext}
                //                         className="btn btn-primary"
                //                     >
                //                         Continue
                //                     </button>
                //                 )}
                //             </div>
                //         </div>
                //     </>
                // </div>
                <>
                    <div className="container mt-4 mb-4">
                        <div className="card border shadow-sm p-3">
                            <div className="mb-4">
                                <h2 className="h4 fw-semibold text-dark">
                                    NCAF Pilot Benefits Readiness
                                </h2>
                            </div>

                            <div className="space-y-5">
                                <div className="row g-3">
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Provider Name</label>
                                        <input
                                            type="text"
                                            value={formData.provider_name}
                                            className="form-control"
                                            onChange={(e) =>
                                                handleInputChange("provider_name", e.target.value)
                                            }
                                            placeholder="Enter provider or center name"
                                        />
                                        {validationErrors.provider_name && (
                                            <div className="invalid-feedback d-block">
                                                {validationErrors.provider_name}
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Contact Name</label>
                                        <input
                                            type="text"
                                            value={formData.contact_name}
                                            className="form-control"
                                            onChange={(e) =>
                                                handleInputChange("contact_name", e.target.value)
                                            }
                                            placeholder="Contact Person Name"

                                        />
                                        {validationErrors.contact_name && (
                                            <div className="invalid-feedback d-block">
                                                {validationErrors.contact_name}
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Email</label>
                                        <input
                                            type="email"
                                            disabled
                                            value={formData.contact_email}
                                            className="form-control"
                                            onChange={(e) => handleInputChange("contact_email", e.target.value)}
                                            placeholder="email@example.com"
                                        />
                                        {validationErrors.contact_email && (
                                            <div className="invalid-feedback d-block">
                                                {validationErrors.contact_email}
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="form-label text-primary mb-1 font-weight-semibold">Phone</label>
                                        <input
                                            type="tel"
                                            value={formData.contact_phone}
                                            className="form-control"
                                            onChange={(e) => handleInputChange("contact_phone", e.target.value)}
                                            placeholder="Phone No"
                                        />
                                    </div>
                                </div>
                                <div className="row g-3 mt-1">
                                    <div className="col-sm-4">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">City</label>
                                        <input
                                            type="text"
                                            value={formData.city}
                                            className="form-control"
                                            onChange={(e) => handleInputChange("city", e.target.value)}
                                            placeholder="Enter City"
                                        />
                                        {validationErrors.city && (
                                            <div className="invalid-feedback d-block">
                                                {validationErrors.city}
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-sm-4">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">State</label>
                                        <select
                                            value={formData.state}
                                            className="form-control"
                                            onChange={(e) => handleInputChange("state", e.target.value)}
                                            placeholder="Optional"
                                        >
                                            {STATES.map((state) => (
                                                <option key={state.value} value={state.value}>
                                                    {state.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-sm-4">
                                        <label className="form-label text-primary mb-1 font-weight-semibold required">Country</label>
                                        <input
                                            type="text"
                                            value={formData.country}
                                            className="form-control"
                                            onChange={(e) => handleInputChange("country", e.target.value)}
                                            placeholder="Enter Country"
                                        />
                                        {validationErrors.country && (
                                            <div className="invalid-feedback d-block">
                                                {validationErrors.country}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="mt-4">
                                    <OptionCardGroup
                                        label={
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                <span className="fw-medium">
                                                    Provider Type
                                                </span>
                                                <span className="text-danger small fw-semibold">
                                                    Required
                                                </span>
                                            </div>
                                        }
                                        // label="Provider Type"
                                        options={providerTypeOptions}
                                        value={formData.provider_type}
                                        onChange={(value) => handleInputChange("provider_type", value)}
                                    />
                                </div>
                                <div className="mt-4">
                                    <OptionCardGroup
                                        label={
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                <span className="fw-medium">
                                                    Approximate Staff Count
                                                </span>
                                                <span className="text-danger small fw-semibold">
                                                    Required
                                                </span>
                                            </div>
                                        }
                                        // label="Approximate Staff Count"
                                        options={staffCountOptions}
                                        value={formData.staff_count_range}
                                        onChange={(value) =>
                                            handleInputChange("staff_count_range", value)
                                        }
                                    />
                                </div>

                                <div className="mt-4">
                                    <OptionCardGroup
                                        label={
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                <span className="fw-medium">
                                                    Main Support Interest
                                                </span>
                                                <span className="text-danger small fw-semibold">
                                                    Required
                                                </span>
                                            </div>
                                        }
                                        // label="Main Support Interest"
                                        options={mainSupportInterestOptions}
                                        value={formData.support_interest}
                                        onChange={(value) =>
                                            handleInputChange("support_interest", value)
                                        }
                                    />
                                </div>
                                <div className="mt-4">
                                    <OptionCardGroup
                                        label={
                                            <div className="d-flex justify-content-between align-items-center w-100">
                                                <span className="fw-medium">
                                                    CTA / Request Type
                                                </span>
                                                <span className="text-danger small fw-semibold">
                                                    Required
                                                </span>
                                            </div>
                                        }
                                        // label="CTA / Request Type"
                                        options={CTARequesTypeOptions}
                                        value={formData.request_type}
                                        onChange={(value) =>
                                            handleInputChange("request_type", value)
                                        }
                                    />
                                </div>
                            </div>

                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="processingConsent"
                                    checked={formData.processing_consent}
                                    onChange={(e) =>
                                        handleInputChange("processing_consent", e.target.checked)
                                    }
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="processingConsent"
                                >
                                    I authorize NCAF to collect and use the information I provide to respond to my inquiry, route me to the Benefits Readiness Survey, and provide readiness-related follow-up. I understand NCAF provides readiness guidance and partner coordination only and does not act as an insurance broker, benefits administrator, payroll provider, legal advisor, tax advisor, or licensing authority.
                                </label>
                            </div>

                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="ncafFollowUpConsent"
                                    checked={formData.ncaf_follow_up_consent}
                                    onChange={(e) =>
                                        handleInputChange("ncaf_follow_up_consent", e.target.checked)
                                    }
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="ncafFollowUpConsent"
                                    style={{ wordSpacing: "2px", lineHeight: "20px" }}
                                >
                                    I would like an authorized NCAF representative to contact me about the NC Pilot and Benefits Readiness Survey.
                                </label>
                            </div>

                            {concentErrors.processing_consent && (
                                <div className="text-danger mb-3">
                                    Please authorize NCAF to process your Benefits Readiness submission before continuing.
                                </div>
                            )}

                            <div className="d-flex justify-content-between mt-4">
                                <button
                                    type="button"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                    className="btn btn-outline-secondary"
                                >
                                    {/* Submit */}
                                    {loading ? "Submitting..." : "Submit Benefits Readiness Intake"}
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <WorkerFooter />
        </>
    );
};

export default FreePilotRegistration;